import React from "react";
import styled from "styled-components";
import { Badge, Input } from "antd";
import SvgIcon from "../../../../assets/icons/icon";
import { MixStyle } from "../../../../styles";
import Account from "./Account";
const { Search } = Input;

const RightBox = styled.div`
  ${MixStyle.flexArround}
  flex-wrap:wrap;

  @media (max-width: 520px) {
    .right--box__serach,
    .right--box_account {
      width: 100%;
    }
  }
  .right--box_account {
    ${MixStyle.flexArround}
    flex-wrap:wrap;
  }
  .my-2 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  .topbar-divider {
    width: 0px;
    border-right: 1px solid #dfe0eb;
    height: calc(4.375rem - 2rem);
    margin: auto 1rem;
  }
`;
const StyledSearch = styled(Search)`
  width: 100%;
  border: none;
  .ant-input-search-icon::before {
    border-left: none;
  }
`;

const RightMenu = () => {
  return (
    <RightBox>
      <div className="right--box__serach my-2">
        <StyledSearch
          placeholder="input search text"
          onSearch={(value) => console.log(value)}
        />
      </div>

      <div className="right--box_account">
        <Badge status="success" dot>
          <SvgIcon icon="notifyIcon" color="#C5C7CD" width={14} height={16} />
        </Badge>
        <div className="topbar-divider"></div>
        <Account />
      </div>
    </RightBox>
  );
};

export default RightMenu;
